/**
 * Allowed calendar years for high school graduation and planned first year of college.
 * Inclusive: referenceYear - 1 through referenceYear + 8.
 */
export const SCHOOL_YEAR_RANGE_OFFSETS = { min: -1, max: 8 } as const

export function getSchoolYearBounds(referenceYear: number = new Date().getFullYear()): {
  min: number
  max: number
} {
  return {
    min: referenceYear + SCHOOL_YEAR_RANGE_OFFSETS.min,
    max: referenceYear + SCHOOL_YEAR_RANGE_OFFSETS.max,
  }
}

export function getAllowedSchoolYears(referenceYear: number = new Date().getFullYear()): number[] {
  const { min, max } = getSchoolYearBounds(referenceYear)
  const out: number[] = []
  for (let y = min; y <= max; y++) out.push(y)
  return out
}
